export default "__VITE_ASSET__ByeVsbRh__"